import client from './client';

const fileUrl = '/api/v1/file';

//파일 리스트 가져오기
export const getFiles = () => client.get(`${fileUrl}/list`);

//파일 추가
export const addFiles = (formData) => {
  return client.post(`${fileUrl}/info`, formData, {
    header: { 'Content-type': 'multipart/form-data' },
  });
};

//파일 정보
export const getFile = (id) => client.get(`${fileUrl}/info/${id}`);

export const editFile = (id, dataToSubmit) => {
  return client.put(`${fileUrl}/info/${id}`, dataToSubmit);
};

//파일 삭제
export const removeFile = (id) => client.delete(`${fileUrl}/info/${id}`);

//피일다운로드
export const downloadFile = (id) => client.get(`${fileUrl}/info/${id}/data`);

//프로필 업로드
export const uploadProfile = (formData) => {
  return client.put(`${fileUrl}/profile`, formData, {
    header: { 'Content-type': 'multipart/form-data' },
  });
};

//기술 파일 추가
export const addTechFiles = (formData) => {
  return client.post(`${fileUrl}/info/tech`, formData, {
    header: { 'Content-type': 'multipart/form-data' },
  });
};

export const downloadNew = async (param) => {
  const token = localStorage.getItem('access_token').toString().replaceAll(/\"/g,'');

 try {
             ///api/v1/file
             //const token = localStorage.getItem('access_token');
             const response = await fetch(`${fileUrl}/info/${param.id}/data`,{
                                         'method': 'GET',
                                         'headers' : {
                                             'Authorization': `Bearer ${token}`,
                                             // 필요에 따라 Content-Type 등을 추가
                                         }});
                                            
             const blob = await response.blob(); // Blob으로 변환
 
             const url = window.URL.createObjectURL(blob);
             const link = document.createElement('a');
             link.href = url;
             link.setAttribute('download', param.value);
             document.body.appendChild(link);
             link.click();
             link.remove();
             window.URL.revokeObjectURL(url);
 
         } catch (err) {
             
         }
}

export const profileImage = async (param) => {
  param =param.replace(/^.*[\\\/]|(\.[^.]+$)/g, "");
  const token = localStorage.getItem('access_token').toString().replaceAll(/\"/g,'');
  const response = await fetch(`/api/v1/file/profile/image/${param}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`, // JWT 토큰
    },
  });
  if (!response.ok) throw new Error('이미지 로드 실패');
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  return url;
}